import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[100],
    padding: '16px 16px',
    borderRadius: 4,
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      height: 'auto',
      padding: 16
    }
  },
  selectFields: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    alignItems: 'center'
  },
  ButtonsContainer: {
    display: 'flex',
    marginTop: 25,
    flexDirection: 'row',
    gap: 0,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      gap: 8
    }
  },
  resetButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[700]}`,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  applyButton: {
    minHeight: 38,
    width: 116,
    fontSize: 16,
    color: `${theme.palette.grey[200]}`,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))
export default useStyles
